<template>
  <div>
    <v-btn
      class="mr-3"
      v-if="items && items.length > 0"
      color="green"
      dark
      @click="$toExcel(items,title ? title : 'data')"
    >
      <v-icon>mdi-file-excel-box</v-icon>
    </v-btn>
    <v-data-table :items="items" :headers="headersComp" hide-default-footer></v-data-table>
  </div>
</template>

<script>
export default {
props:['items','title'],
name: "table-dynamic",
data(){
    return{

    }
},
methods:{

},
computed:{
       headersComp(){
      if(!this.items || this.items.length == 0) return []
      let headers = []
      let properties = Object.keys(this.items[0]);
      properties.splice(properties.length,1)
      properties.forEach(p => headers.push(
          {
          text: p,
          align: "left",
          sortable: true,
          value: p,
        },
      ));
      return headers;
    }
  },
}

</script>

<style>

</style>